import { useState } from 'react';
import { useNavigate } from 'react-router-dom-v5-compat';
import { useTranslation } from 'react-i18next';
import { PageHeaderWithActions } from 'src/components/molecules/PageHeaderWithActions';
import {
  ReportCard,
  ReportCardSummaryType,
} from '../../Common/ReportCard/ReportCard';
import { ReportingMessageSlideIn } from '../ReportingMessageSlideIn';
import { ReportingNoReports } from '../ReportingNoReports/ReportingNoReports';
import { ReportsListContainer } from './ReportingReportsList.styled';

interface Props {
  reports: ReportCardSummaryType[] | undefined | null;
}
export const ReportingReportsListView = ({ reports }: Props) => {
  const [currentReport, setCurrentReport] = useState<
    ReportCardSummaryType | undefined
  >(undefined);
  const [messageSlideInOpen, setMessageSlideInOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleOpenReport = (reportId: string) => {
    navigate(`${reportId}`);
  };

  const hasReports = reports && reports.length > 0;

  return (
    <>
      {currentReport && (
        <ReportingMessageSlideIn
          open={messageSlideInOpen}
          setOpen={setMessageSlideInOpen}
          reportDetails={{
            internalId: currentReport.report,
            reportReadableId: currentReport.reportReadableId,
            submittedAt: currentReport.submittedAt,
            status: currentReport.status,
            category: currentReport.category || '',
          }}
          onClose={() => setCurrentReport(undefined)}
        />
      )}
      <PageHeaderWithActions title={t('reporting.ReportList.yourReports')} />
      <ReportsListContainer>
        {hasReports ? (
          reports.map((report) => (
            <ReportCard
              key={report.report}
              report={report}
              version="report-list"
              // TODO: add onReportOpen, onAddEvidenceSelected, onMessageCaseManagerSelected
              onReportOpen={() => handleOpenReport(report.report)}
              onAddEvidenceSelected={() =>
                navigate(`${report.report}/add-evidence`)
              }
              onMessageCaseManagerSelected={() => {
                setCurrentReport(report);
                setMessageSlideInOpen(true);
              }}
            />
          ))
        ) : (
          <ReportingNoReports hasError={!reports} />
        )}
      </ReportsListContainer>
    </>
  );
};
